module.exports = __webpack_public_path__ + "static/media/Mission-MSA_Symbol_White_Color-Background_RGB.46c60adb.png";